type OneEvoMigratableContract = {
  oneEvoMigrated?: boolean | null;
};

/**
 * A contract migrated to OneEvo is read only: the contract and all of its lines
 * can no longer be edited, while its billing keeps running unchanged.
 */
export const isContractOneEvoMigrated = (contract?: OneEvoMigratableContract | null): boolean =>
  Boolean(contract?.oneEvoMigrated);

export const ONE_EVO_MIGRATED_MESSAGE =
  'This contract has been migrated to OneEvo and is read only.';
